import * as React from "react";

export const IndicatorIcon = ({ color, props }: any) => {
  return (
    <svg width={14} height={9} viewBox="0 0 14 9" fill="none" {...props}>
      <path
        d="M12.917 1L7.77 6.146 5.063 3.438 1 7.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.666 1h3.25v3.25"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
